export const MAX_HABIT_NAME_LENGTH = 28;
